import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'myTasks'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/login/index.vue')
    },
    {
      // 我的催收任务列表
      path: '/myTasks',
      name: 'myTasks',
      component: () => import('../views/myTasks/list.vue')
    },
    {
      // 催收任务detail
      path: '/task/:taskId/:loanId/:status',
      name: 'taskDetail',
      component: () => import('../views/myTasks/item.vue'),
      meta: {
        title: '催收任务列表',
        former: {
          path: '',
          name: 'taskDetail',
          component: () => import('../views/myTasks/list.vue'),
          meta: {
            title: '催收任务'
          }
        }
      }
    },
    {
      // 委外队列
      path: '/outSourcingTask',
      name: 'outSourcingTask',
      component: () => import('../views/management/outSourcingTask.vue')
    },
    {
      // 特殊队列
      path: '/specialTask',
      name: 'specialTask',
      component: () => import('../views/management/specialTask.vue')
    },
    {
      // 催记管理
      path: '/CollectionLog',
      name: 'CollectionLog',
      component: () => import('../views/management/CollectionLog.vue')
    },
    {
      // 数据统计
      path: '/statistics',
      name: 'statistics',
      component: () => import('../views/myTasks/statistics.vue')
    },
    {
      // 还款detail
      path: '/conditions/:taskId',
      name: 'conditions',
      component: () => import('../views/myTasks/conditions.vue'),
      meta: {
        title: '催收任务',
        former: {
          path: '',
          name: 'conditions',
          component: () => import('../views/myTasks/conditions.vue'),
          meta: {
            title: '还款计划'
          }
        }
      }
    },
    {
      // 队列管理
      path: '/manage/queue',
      name: 'manage-queue',
      component: () => import('../views/management/queue.vue')
    },
    {
      // 队列管理 auto
      path: '/manage/autoQueue',
      name: 'manage-auto-queue',
      component: () => import('../views/management/autoQueue.vue')
    },
    {
      // 批量分案
      path: '/manage/batchTasks',
      name: 'manage-batch-tasks',
      component: () => import('../views/management/batchTasks.vue')
    },
    {
      // 委外分案
      path: '/manage/OutsourceDivisionTasks',
      name: 'manage-batch-OutsourceDivisionTasks',
      component: () => import('../views/management/OutsourceDivisionTasks.vue')
    },
    {
      // 留案管理
      path: '/manage/StayOnFile',
      name: 'manage-batch-StayOnFile',
      component: () => import('../views/management/StayOnFile.vue')
    },
    {
      // 队列管理 auto
      path: '/manage/queue/tasks/:queueId',
      name: 'manage-queue-tasks',
      component: () => import('../views/management/queueTasks.vue'),
      meta: {
        title: '队列管理',
        former: {
          path: '',
          name: 'manage-queue-tasks',
          component: () => import('../views/management/queueTasks.vue'),
          meta: {
            title: '队列管理'
          }
        }
      }
    },
    {
      // 用户管理
      path: '/manage/user/list',
      name: 'manage-user-list',
      component: () => import('../views/management/users.vue')
    },
    {
      // 度言坐席管理
      path: '/manage/dyuser/list',
      name: 'manage-dyuser-list',
      component: () => import('../views/management/dyusers.vue')
    },
    {
      // 用户管理
      path: '/manage/user/:uid?',
      name: 'manage-user-info',
      component: () => import('../views/management/userInfo.vue'),
      meta: {
        title: '用户管理',
        former: {
          path: '',
          name: 'manage-user-list',
          component: () => import('../views/management/users.vue'),
          meta: {
            title: '新增用户'
          }
        }
      }
    },
    {
      // 度言用户管理
      path: '/manage/dyuser/:uid?',
      name: 'manage-dyuser-info',
      component: () => import('../views/management/dyuserInfo.vue'),
      meta: {
        title: '度言用户管理',
        former: {
          path: '',
          name: 'manage-dyuser-list',
          component: () => import('../views/management/dyusers.vue'),
          meta: {
            title: '新增度言员工编号'
          }
        }
      }
    },
    {
      // 绩效管理
      path: '/achievements/search',
      name: 'achievements-search',
      component: () => import('../views/achievements/search.vue')
    },
    {
      // 机构管理
      path: '/mechanism',
      name: 'mechanism',
      component: () => import('../views/systemAdministration/mechanism.vue')
    },
    {
      // 模板管理
      path: '/template',
      name: 'template',
      component: () => import('../views/systemAdministration/template.vue')
    },
    {
      // 下载中心
      path: '/download',
      name: 'download',
      component: () => import('../views/download/download.vue')
    },
    {
      // 委案报表导出
      path: '/comReportExport',
      name: 'comReportExport',
      component: () => import('../views/reportExport/comReportExport.vue')
    },
    {
      // 逾期表导出
      path: '/overdueReportExport',
      name: 'overdueReportExport',
      component: () => import('../views/reportExport/overdueReportExport.vue')
    },
    {
      // 委外清单报表导出
      path: '/outsourceBillReportExport',
      name: 'outsourceBillReportExport',
      component: () => import('../views/reportExport/outsourceBillReportExport.vue')
    }
  ]
})
